import { deleteField,doc, getDoc, updateDoc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';
import CounterChart from '@src/models/CounterChart';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToCounterByDivision,
  getRouteToCounterByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class CounterChartRepository {
  constructor() {
    this.counterChart = new CounterChart();
  }

  getCollectionPath(orgId, divId = null, boardId) {
    if (divId) {
      return getRouteToCounterByDivision(orgId, divId, boardId);
    }
    return getRouteToCounterByOrg(orgId, boardId);
  }

  async create({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.counterChart.setData(data);
      const res = await createOperation(collectionPath, null, this.counterChart, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.counterChart.setData(data);
      const counterChartData = this.counterChart.toUpdate();
      const counterChartRef = doc(db, collectionPath, chartId);
      // Delete the queryParams field to replace completely
      if (counterChartData?.queryParams !== undefined) {
        await updateDoc(counterChartRef, {
          queryParams: deleteField(),
        });
      }
      await createOperation(collectionPath, chartId, counterChartData, ACTIONS.UPDATE);
      return counterChartData;
    }).catch(error => {
      throw error;
    });
  }

  async get({ orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const counterChartRef = doc(db, collectionPath, chartId);
      const counterChartDoc = await getDoc(counterChartRef);
      
      if (counterChartDoc.exists()) {
        return { id: counterChartDoc.id, ...counterChartDoc.data() };
      }
      return null;
    }).catch(error => {
      throw error;
    });
  }
}

export default CounterChartRepository;
